module.exports = __webpack_public_path__ + "static/img/xx.5bedb461.png";